import axios from "axios";

/* Sign-out. The request uses its own client, so a 401 interceptor on the staff client cannot
   redirect it. A hang ends on the timeout; the user and any staff or console session are
   cleared in finally even when the call fails. */
export const LOGOUT_TIMEOUT_MS = 4000;
export const STAFF_SESSION_KEY = "nimbus_staff_session";
export const CONSOLE_SESSION_KEY = "nimbus_console_session";

export function logoutRequestConfig() {
  return { withCredentials: true, timeout: LOGOUT_TIMEOUT_MS, skipAuthRedirect: true };
}

export function clearStoredSessions() {
  try {
    sessionStorage.removeItem(STAFF_SESSION_KEY);
    sessionStorage.removeItem(CONSOLE_SESSION_KEY);
  } catch { /* storage blocked */ }
}

function withTimeout(promise, ms) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      const error = new Error("timeout");
      error.code = "ECONNABORTED";
      reject(error);
    }, ms);
    promise.then(
      (value) => { clearTimeout(timer); resolve(value); },
      (error) => { clearTimeout(timer); reject(error); },
    );
  });
}

/* A fresh client has no redirect interceptor. `skipAuthRedirect` is set for any interceptor
   that later wraps the shared client. */
export function logoutClient() {
  return axios.create({ withCredentials: true });
}

export async function signOut({ post, setUser, navigate }) {
  const config = logoutRequestConfig();
  try {
    await withTimeout(post("/auth/logout", {}, config), config.timeout);
  } catch { /* failure, 401, or a call that never returns */ }
  finally {
    clearStoredSessions();
    if (setUser) setUser(null);
    if (navigate) navigate("/login", { replace: true });
  }
}
